module.exports = function() {
  return new Worker(__webpack_public_path__ + "8035e76e4ec6843b003e.worker.js");
};